module.exports = __webpack_public_path__ + "static/media/tab3-filled.8343e41a.png";